import React from 'react';
import { Cell } from 'fixed-data-table';

const DiscussionCell = ({rowIndex, sortedData, columnKey, onClick, ...props}) => (
  <Cell {...props} onClick={ e => {if(onClick) onClick(e, rowIndex, sortedData);}}>
    {/*<Glyphicon glyph="comment" 
      style={{
        color: 'rgba(134, 134, 134, .7)',
        width: 30
      }} />*/}
    <span className='discussion-icon-span'></span>

    {
      // 因api的不一致性先轉為文字…
      sortedData.getObjectAt(rowIndex)[columnKey].toString() === '0' ?
        ""
      :
        <span className="discussion-span">
          {sortedData.getObjectAt(rowIndex)[columnKey]}
        </span>
    }
  </Cell>
);

export default DiscussionCell;


// WEBPACK FOOTER //
// ./src/salesky/routes/workLog/DiscussionCell.jsx